import axios from 'axios';

// FizyofiAdsAPI, FizyofiAPI'den ayrı bir .NET servisi (kendi REKLAMLAR veritabanı, kendi portu).
// Reklam hesabı şirket geneli tek hesap olduğu için X-Sube-Kod header'ı gönderilmiyor —
// Etkinlik Hasta Kaydı'nın CallCenterDbContext deseniyle aynı mantık: şubeden bağımsız.
const apiUrl = process.env.REACT_APP_ADS_API_URL || 'http://localhost:5090/api';

const ReklamAPI = axios.create({
  baseURL: apiUrl,
});

export const getSaglik = () => ReklamAPI.get('/saglik');
export const getPerformansOzet = () => ReklamAPI.get('/performans/ozet');
export const performansAnalizEt = (baslangic, bitis) => ReklamAPI.get('/performans/analiz-et', { params: { baslangic, bitis } });
// Arka planda çalıştırıp ilerlemeyi sormak için (2026-08-16, gerçek ilerleme çubuğu).
export const analizBaslat = (baslangic, bitis) => ReklamAPI.post('/performans/analiz-baslat', null, { params: { baslangic, bitis } });
export const analizDurum = (isId) => ReklamAPI.get(`/performans/analiz-durum/${isId}`);
export const getLeadFormOzeti = (baslangic, bitis) => ReklamAPI.get('/lead/form-ozeti', { params: { baslangic, bitis } });
export const beniaraEslestir = () => ReklamAPI.post('/lead/beniara-eslestir');

// Faz 2 — haftalık kampanya sağlık taraması ve onay kuyruğu (2026-08-16).
// kaydet=false: sadece göster, kuyruğa karar yazma.
export const haftalikTarama = (gun = 14, kaydet = false) =>
  ReklamAPI.get('/karar/haftalik-tarama', { params: { gun, kaydet } });
export const bekleyenKararlar = () => ReklamAPI.get('/karar/bekleyenler');
export const aiOneriler = (durum = 'Bekliyor') => ReklamAPI.get('/karar/oneriler', { params: { durum } });
export const oneriDetay = (id) => ReklamAPI.get(`/karar/${id}`);
// Üç seviyeli sağlık ağacı: kampanya → reklam seti → reklam (2026-08-16).
export const saglikAgaci = (gun = 14) => ReklamAPI.get('/karar/saglik-agaci', { params: { gun } });
// Arka planda tarama + gerçek ilerleme (2026-08-17).
export const agacBaslat = (gun = 14) => ReklamAPI.post('/karar/agac-baslat', null, { params: { gun } });
export const agacDurum = (isId) => ReklamAPI.get(`/karar/agac-durum/${isId}`);
export const oneriGonder = (govde) => ReklamAPI.post('/karar/oneri-gonder', govde);
export const kararOnayla = (id) => ReklamAPI.post(`/karar/${id}/onayla`);
export const kararReddet = (id) => ReklamAPI.post(`/karar/${id}/reddet`);

// Medya dosyalarini <img>/<video> ile gostermek icin mutlak adres gerekiyor (axios degil tarayici cekiyor).
export const reklamApiKok = apiUrl;

export default ReklamAPI;

// Onaylanan butce kararini Meta'ya uygular / geri alir (2026-08-18).
export const kararUygula = (id, yeniButce, yeniOlustur) => ReklamAPI.post(`/karar/${id}/uygula`, null, { params: { yeniButce, yeniOlustur } });
export const kararGeriAl = (id) => ReklamAPI.post(`/karar/${id}/geri-al`);

// Kullanicinin kendi is emri: bu sete yeni reklam acilsin (2026-08-18).
export const yeniReklamIste = (govde) => ReklamAPI.post('/karar/yeni-reklam-iste', govde);
// Ayarlar ekrani (2026-08-18) — degisiklikler anlik gecerli, servis yeniden baslatilmaz.
export const ayarlariGetir = () => ReklamAPI.get('/ayar');
export const ayarKaydet = (anahtar, deger) => ReklamAPI.post('/ayar/kaydet', { anahtar, deger });
export const ayarVarsayilanaDon = (anahtar) => ReklamAPI.post(`/ayar/${anahtar}/varsayilana-don`);
export const fabrikaAyarlari = () => ReklamAPI.post('/ayar/fabrika-ayarlari');
export const butceArtir = (govde) => ReklamAPI.post('/karar/butce-artir', govde);
// Faz 3 — icerik uretim dongusu (2026-08-19).
export const icerikKararaGore = (kararId) => ReklamAPI.get(`/icerik/karara-gore/${kararId}`);
// tur=resim|video, kaynak=resim|video — brief tur secildikten SONRA yazilir.
// Secilen uretim turune uygun sablonlar (kullanici tercih edebilsin diye).
export const icerikSablonlar = (tur, kaynak) => ReklamAPI.get(`/icerik/sablonlar`, { params: { tur, kaynak } });
// ANA FİKİR gövdede gider (2026-08-25): serbest metin, adres satırına sığmayabilir.
export const briefUret = (kararId, secim) => {
  const { anaFikir, ...params } = secim || {};
  return ReklamAPI.post(`/icerik/brief-uret`, { anaFikir: anaFikir || null }, { params: { kararId, ...params } });
};
export const icerikParca = (id, govde) => ReklamAPI.post(`/icerik/${id}/parca`, govde);
export const icerikMedyaTuru = (id, tur, not) => ReklamAPI.post(`/icerik/${id}/medya-turu`, null, { params: { tur, not } });
// URET adimi: TopView'de gorsel/video uretir. Video 10+ dakika surebildigi icin istemci
// zaman asimi ozellikle uzun tutuldu (varsayilan axios timeout'u yetmiyor).
export const icerikUret = (id, secim) => ReklamAPI.post(`/icerik/${id}/uret`, null, { params: secim, timeout: 22 * 60 * 1000 });
export const icerikUretimBilgisi = () => ReklamAPI.get('/icerik/uretim-bilgisi');
// YAYINLA — final dosyayi Meta'ya yukleyip AYNI SETE yeni reklam acar (ACTIVE).
export const icerikYayinOnizleme = (id, setId) => ReklamAPI.get(`/icerik/${id}/yayin-onizleme`, { params: { setId } });
export const icerikYayinla = (id, setId) => ReklamAPI.post(`/icerik/${id}/yayinla`, null, { params: { setId }, timeout: 8 * 60 * 1000 });
export const icerikYayiniDurdur = (id) => ReklamAPI.post(`/icerik/${id}/yayini-durdur`);
export const icerikOnizlemeTazele = (id) => ReklamAPI.post(`/icerik/${id}/onizleme-tazele`);
// "Durdu mu, yayinda mi" sorusunu Meta'ya sorar — ekran tahmin yurutmez.
export const icerikYayinDurumu = (id) => ReklamAPI.get(`/icerik/${id}/yayin-durumu`);
export const icerikYayiniBaslat = (id) => ReklamAPI.post(`/icerik/${id}/yayini-baslat`);
// Reklamin gomulebilir onizlemeleri (Facebook/Instagram yerlesimleri) — kendi ekranimizda.
export const icerikOnizlemeler = (id) => ReklamAPI.get(`/icerik/${id}/onizlemeler`);
// Yayinlanmis icerikten yeni surum turetir (eskisi dokunulmaz kalir).
export const icerikYeniSurum = (id) => ReklamAPI.post(`/icerik/${id}/yeni-surum`);
// Gozden Gecir onerisinin uc cikisi: goruldu | pasife | yenile
export const gozdenGecirEylem = (id, eylem) => ReklamAPI.post(`/karar/${id}/gozden-gecir`, null, { params: { eylem } });

// Brief iptal — is emrini "hic brief yazilmamis" haline dondurur (2026-10-02).
// Sunucu uretimi Reddedildi isaretler; karara-gore ve brief-uret o satiri yok sayar.
export const icerikBriefIptal = (id) => ReklamAPI.post(`/icerik/${id}/reddet`);
// Uretim arka planda calisiyor; ekran durumu buradan sorar.
export const icerikDetay = (id) => ReklamAPI.get(`/icerik/${id}`);
// Kullanicinin kendi gorseli — yuklerse TopView atlanir (2026-08-22).
export const kendiGorselimYukle = (id, dosya) => {
  const form = new FormData();
  form.append('dosya', dosya);
  return ReklamAPI.post(`/icerik/${id}/kendi-gorselim`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const kendiGorselimIptal = (id) => ReklamAPI.post(`/icerik/${id}/kendi-gorselim-iptal`);
// Creatomate sablon yonetimi (Ayarlar > Sablonlar) — 2026-08-24.
export const sablonListe = () => ReklamAPI.get('/sablon');
export const sablonEkle = (govde) => ReklamAPI.post('/sablon', govde);
export const sablonGuncelle = (id, govde) => ReklamAPI.post(`/sablon/${id}/guncelle`, govde);
export const sablonDurum = (id, aktif) => ReklamAPI.post(`/sablon/${id}/durum`, null, { params: { aktif } });
// Uc asamali uretim (2026-08-25): medya -> ses -> final. Her asama ayri ayri yenilenebilir.
// Yayınlanmış reklamın tam karnesi: Meta rakamları + lead/randevu/ciro (2026-08-31).
// Klinik veritabanları taranıyor, birkaç saniye sürebilir.
export const icerikPerformans = (id) =>
  ReklamAPI.get(`/icerik/${id}/performans`, { timeout: 5 * 60 * 1000 });

// HESAP YAPISI VE KLONLAMA (2026-09-06): agac ayri ayri sorulur, hepsi tek istekte cekilmez.
export const yapiKampanyalar = () => ReklamAPI.get('/yapi/kampanyalar');
export const yapiSetler = (kampanyaId) => ReklamAPI.get(`/yapi/kampanya/${kampanyaId}/setler`);
export const yapiReklamlar = (setId) => ReklamAPI.get(`/yapi/set/${setId}/reklamlar`);
export const yapiKlonla = (govde) => ReklamAPI.post('/yapi/klonla', govde, { timeout: 3 * 60 * 1000 });
export const yapiOnizleme = (reklamId) => ReklamAPI.get(`/yapi/reklam/${reklamId}/onizleme`, { timeout: 2 * 60 * 1000 });
// AKTİF/PASİF — canlı para etkisi var, ekran onay sorar.
export const yapiDurum = (id, aktif) => ReklamAPI.post('/yapi/durum', null, { params: { id, aktif } });
// Ad değiştirme: yalnızca etiket, yayını ve bütçeyi etkilemez.
export const yapiAd = (id, yeniAd) => ReklamAPI.post('/yapi/ad', null, { params: { id, yeniAd } });

// Brief sonrasi cerceve degisikligi: cinsiyet + ana fikir (2026-08-25).
export const cerceveKaydet = (id, cinsiyet, anaFikir) =>
  ReklamAPI.post(`/icerik/${id}/cerceve`, { anaFikir: anaFikir || null }, { params: { cinsiyet: cinsiyet || undefined } });

export const medyaUret = (id, secim) => ReklamAPI.post(`/icerik/${id}/medya-uret`, null, { params: secim, timeout: 10 * 60 * 1000 });
export const sesUret = (id, sesAdi) => ReklamAPI.post(`/icerik/${id}/ses-uret`, null, { params: { sesAdi }, timeout: 5 * 60 * 1000 });
export const finalUret = (id, sablonId) => ReklamAPI.post(`/icerik/${id}/final-uret`, null, { params: { sablonId }, timeout: 10 * 60 * 1000 });
// Seslendirme sesleri (Ayarlar > Şablonlar ekranindan yonetilir).
export const sesListe = () => ReklamAPI.get('/ses');
export const sesEkle = (govde) => ReklamAPI.post('/ses', govde);
export const sesDurum = (id, aktif) => ReklamAPI.post(`/ses/${id}/durum`, null, { params: { aktif } });

// ÖNERİ EKRANI (kullanıcı talebi: 2026-09-29) — kararlar stüdyodan ayrıldı.
// VARSAYILAN 45 -> 120 GUN (2026-10-02): 24 seanslik Pilates ~3 ayda tamamlanir,
// 45 gunde bakmak cironun kucuk bir parcasini gosterir ve kampanyalari yanlis siralar.
export const oneriTara = (gun = 120) => ReklamAPI.post('/oneri/tara', null, { params: { gun } });
export const oneriDurum = (isId) => ReklamAPI.get(`/oneri/durum/${isId}`);
export const oneriBekleyenler = () => ReklamAPI.get('/oneri/bekleyenler');
export const oneriGecmis = (gun = 90) => ReklamAPI.get('/oneri/gecmis', { params: { gun } });
export const oneriGeriGetir = (id) => ReklamAPI.post(`/oneri/${id}/geri-getir`);
// Arşivden kalıcı silme (2026-10-02) — yalnız kullanıcının kendi tıklamasıyla.
export const oneriSil = (id) => ReklamAPI.delete(`/oneri/${id}`);
// Elle is emri acma (2026-10-02): Icerik Studyosu > + Kreatif Yarat
export const isEmriAc = (govde) => ReklamAPI.post('/oneri/is-emri', govde);
// Is emrini iptal et (2026-10-02): Kararlar'dan geldiyse geri doner, elle acildiysa silinir.
export const isEmriIptal = (id) => ReklamAPI.post(`/oneri/${id}/is-emri-iptal`);

// YENİ KAMPANYA / YENİ REKLAM SETİ SİHİRBAZI (kullanıcı talebi: 2026-09-29).
// Önce "önizle" ile ne yazılacağı gösterilir, kullanıcı onaylayınca "oluştur" yazar.
export const sihirbazSecenekler = () => ReklamAPI.get('/sihirbaz/secenekler');
export const kampanyaOnizle = (govde) => ReklamAPI.post('/sihirbaz/kampanya-onizle', govde);
export const kampanyaOlustur = (govde) => ReklamAPI.post('/sihirbaz/kampanya-olustur', govde);
export const setOnizle = (govde) => ReklamAPI.post('/sihirbaz/set-onizle', govde);
export const setOlustur = (govde) => ReklamAPI.post('/sihirbaz/set-olustur', govde);
// Meta'nın yer veritabanında arama — Reklam Seti Yarat'taki konum combobox'ını besler.
export const yerAra = (q, bolgeId) => ReklamAPI.get('/sihirbaz/yer-ara', { params: { q, bolgeId } });
